import { legacyPlugins } from "/opt/suncore/build/20261104T151752Z-16e87b2b/node_modules/nuxt/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}